import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'projects/shackleton-processing2.jpg' satisfies MediaPath
const generations = 'portfolio/CftA-poster.jpg' satisfies MediaPath
const nautilus = 'portfolio/screen-0278.jpg' satisfies MediaPath
const cinet = 'portfolio/cinet-article-img.png' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'shackleton',
	name: 'Shackleton',
	excerpt: 'Data-driven studies in Processing',
	tags: ['generative', 'data'],
	cover,
	order: 10,
}

export default function Shackleton() {
	return (
		<>
			<p>
				A series of plotter-bound studies mapping expedition logs to line fields. Built in
				Processing, exported to vector for pen plotting.
			</p>
			<Gallery
				items={[
					{ src: cover, alt: 'Line field study' },
					{
						src: generations,
						alt: 'Generations — golden-ratio network',
					},
					{
						src: nautilus,
						alt: 'Nautilus — force-directed graph',
					},
					{ src: cinet, alt: 'CINET — network in situ' },
				]}
			/>
		</>
	)
}
